
class CapScheduleRequestControlPanel {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_schedule_request_control_panel'
}

function create(config) {
  return new CapScheduleRequestControlPanel(config)
}

export default {
  key,
  create,
}
